import { QueryClient } from '@tanstack/react-query';

// Shared singleton so non-React code (e.g. the auth store on tenant switch)
// can invalidate/clear cached server state.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 5 * 60 * 1000, // 5 minutes
      refetchOnWindowFocus: false,
    },
  },
});
